<template lang="pug">
  .content-wrapper.col-12(v-if='currentUser.rights.projects == true')
    .table-header.d-flex.pb-2.justify-content-between
      h2.m-0 Проекты
      button.btn.btn-info.col-6(v-show="currentUser.rights.editProjects" v-on:click='importAllProjects') Импортировать все проекты их Море Звонков
      button(v-bind:class="['btn', 'btn-info',  'col-2', {'d-none': currentUser.rights.editProjects == false}]" v-on:click='createProject') Добавить проект
    .clients-table
      .d-flex.mb-2.justify-content-between
        select.form-control.col-3(v-model='selectedFilter')
          option(value='' disabled='' selected='') Выберите тип проекта
          option(value='') Все
          option(value='Базовый') Базовый
          option(value='Индивидуальный') Индивидуальный
        select.form-control.col-3(v-model='selectTransfer')
          option(value='' disabled='' selected='') Наличие переводов
          option(value='0') Все
          option(value='1') Есть
          option(value='2') Нет
        input.form-control.col-5(type='text' v-model='searchQuery' placeholder='Search')
      table.table.table-hover.table-fixed.col-12
        thead
          tr.col-12
            th(v-for='h in columnsHeader' v-bind:key='h.key' v-on:click='sortBy(h.key)' v-bind:class='{ active: sortKey == h.key }')
              | {{ h.title }}
              span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc', {'d-none': h.key =='actions'}]")
        tbody
          tr(v-for='(row, index) in filteredProjects' v-bind:key='row.id')
            td(v-for='td in columnsHeader' v-bind:key='td.id')
              span(v-if="td.key === 'hasTransfer'")
                span(v-if='row.hasTransfer == 0') Нет
                span(v-else-if='row.hasTransfer') Есть
              span(v-else='') {{ row[td.key] }}
              span.td-actions(v-if="td.key === 'actions' && currentUser.rights.editProjects")
                i.far.fa-file(v-if="row.mz_id >0" v-on:click='showModal(row.mz_id)')
                i.far.fa-download(v-if="row.mz_id >0" v-on:click='importProject(row.mz_id)')
                i.far.fa-pen(v-on:click='editProject(row.id)')
                i.far.fa-trash(v-on:click='removeItem(index, row.id)')
              span.td-actions(v-if="td.key === 'actions' && currentUser.rights.editProjects == false")
                i.far.fa-file(v-on:click='showModal(row.mz_id)')
                i.far.fa-eye(v-on:click='editProject(row.id)')
    modal(v-show='isModalVisible' v-on:close='closeModal')
      template(v-slot:header='')
        div.d-block(v-if='showScript > 0')
          h2.col-12 Сценарий разговора по проекту {{ projects.filter(item =&gt; item.mz_id == showScript)[0].name }}
        .row.w-100(v-else='')
          .form-group.col-12
            h2(v-if='currentUser.rights.editProjects == false') Просмотр проекта {{formData.name}}
            h2(v-else-if='!!formData.id') {{formData.name}}
            h2(v-else='') Новый проект
          .form-group.col-12(v-if="currentUser.rights.editProjects")
            button.btn.btn-info.col-2(v-on:click="formSubmit") Сохранить
            span &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            button.btn.btn-secondary.col-2(v-on:click='closeModal') Отмена
      template(v-slot:body='')
        .col-12.h-100(v-if='showScript > 0')
          iframe.col-12.p-0(v-bind:src="systemSettings.mz_api_host +  '/api/getScriptViewForSkewes/' + showScript" name='script-frame' frameborder='0' height='100%')
        div#ProjectForm(v-else='')
          fieldset(v-bind:disabled='currentUser.rights.editProjects == false')
            .form-group.col-12
              label(for='inputName') Название
              input#inputName.form-control(v-model='formData.name' type='text' placeholder='Введите название проекта' required='')
            .form-group.col-12
              label(for='inputID_morezvonkov') ID Море звонков
              input#inputID_morezvonkov.form-control(v-model='formData.mz_id' type='number' placeholder='Введите ID Море звонков')
            //- .form-group.col-12
              label(for='inputOrganization') Компания
              input#inputOrganization.form-control(v-model='formData.company' type='text' placeholder='Введите название компании' required='')
            .form-group.col-12
              label Тип проекта
              select.form-control(v-model='formData.project_type')
                option(value='Базовый') Базовый
                option(value='Индивидуальный') Индивидуальный
            .form-group.col-12(v-if="formData.hasTransfer")
              h4.col-12.p-0.mt-5.mb-3 Переводы
              .row.mb-2
                .col-10.text-left
                  h5 Отдел
                .col-2.text-right
                  h5 Телефон
              .row.mb-2(v-for='transfer in formData.transfers' v-bind:key='transfer.value')
                .col-10.text-left {{ transfer.title }}
                .col-2.text-right {{ transfer.value }}
            .results-list.col-12
              .row.w100
                h4.col-12.mt-5 Цели звонка
                .col-6
                  h5.border-bottom.text-center Общие цели
                  p.col-12.p-0(v-for='result in commonResults' v-bind:key='result.id') {{result.name}}
                .col-6
                  p.border-bottom.text-center Дополнительные цели
                  .row.mb-3(v-for='specialResult in specialResults' v-bind:key='specialResult.id')
                    .col-12(v-if='!currentUser.rights.editProjects') {{specialResult.name}}
                    .col-9(v-if="currentUser.rights.editProjects")
                      input.form-control(v-focus='' v-if='currentUser.rights.editProjects' v-model='specialResult.name')
                    label.pointer.text-right(v-if='currentUser.rights.editProjects' v-on:click='deleteSpecialResults(specialResult.id)')
                      i.far.fa-times
                      | &nbsp;Удалить
                  .row
                    .col-12.pointer(v-if='currentUser.rights.editProjects' v-on:click='addSpecialResult(formData.id)')
                      i.align-self-center.far.fa-plus
                      | &nbsp; Добавить цель
            .form-group.col-12
              h4.col-12.p-0.mt-5 Дополнительные поля
              div(v-for='(cf,index) in formData.customFields' v-bind:key='cf.id')
                .form-group.field-section.pb-3.mb-3.row.m-0(v-if="cf.project_id != 0")
                  .col-3.pl-0.mt-2
                    label(v-bind:for="'labelCustomField'+cf.id") Название поля
                    input.form-control(v-model='cf.label' type='text' v-bind:id="'labelCustomField'+cf.id" v-focus='')
                  .col-3.mt-2
                    label.col-12.p-0(v-bind:for="'typeCustomField'+cf.id") Тип поля
                    select.form-control.col-11(v-model='cf.type')
                      option(v-for='(fieldType, index2) in customFieldTypes' v-bind:key='index2' v-bind:value='fieldType') {{ fieldType }}
                  .col-3.pl-0.mt-2
                    label(v-bind:for="'labelCustomField'+cf.id") Ключ
                    input.form-control(v-model='cf.name' type='text' v-bind:id="'labelCustomField'+cf.id" v-focus='')
                  .col-1.pl-0.mt-2.text-center
                    label Обязательное
                    div.text-center
                      input.form-check-input(v-model='cf.is_required' type='checkbox' value="1")
                  label.pointer.align-self-end(v-show="currentUser.rights.editProjects" v-on:click='deleteCustomField(index)')
                      i.far.fa-times
                      | &nbsp;Удалить
                  .col-12.p-0(v-if="cf.type == 'select'" v-bind:id="'labelCustomField'+cf.id")
                    .row.mt-3.p-0(v-for='(option, index3) in cf.values' v-bind:key='index3')
                      .col-6 &nbsp;
                      .col-5
                        input.form-control(v-model='cf.values[index3]' type='text' v-focus='')
                      label.pointer.align-self-end(v-show="currentUser.rights.editProjects" v-on:click='cf.values.splice(index3, 1)')
                        i.far.fa-times
                    .row.mt-3
                      .col-6 &nbsp;
                      .col-4
                        span.pointer(v-if="cf.type == 'select' && currentUser.rights.editProjects" v-on:click="cf.values.push('')")
                          i.align-self-center.far.fa-plus
                          | &nbsp; Добавить значение списка
                      //- i(v-bind:class="['fal', 'fa-times-square', 'align-self-center', 'mx-2', {'d-none': currentUser.rights.editProjects  == false}]" v-on:click='cf.values.splice(index3, 1)' title='Удалить пункт')
              span(v-bind:class="['btn', 'btn-info', 'col-3', {'d-none': currentUser.rights.editProjects == false}]" v-on:click='addCustomField') Добавить поле
            .form-group.col-12.mt-4
              input.form-check-input#display-last-call(v-model="displayLastCall" type="checkbox" value="1" :disabled="!currentUser.rights.editProjects")
              label.form-check-label(for="display-last-call") Отображать оператору предыдущий звонок клиента в скрипте
      template(v-slot:footer='')
        //- .form-group.d-flex.justify-content-between.col-12
        //-   button(v-bind:class="['btn', 'btn-info', 'col-2', {'d-none': currentUser.rights.editProjects == false}]" type='submit' form='ProjectForm') Сохранить
        //-   button.btn.btn-secondary.col-2(type='submit' v-on:click='closeModal') Отмена
  .alert.alert-info(v-else='' role='alert') У Вас нет прав доступа в этот раздел
</template>
<script>
export default {
  data: function () {
    var columnsHeader = [
      {title: 'ID', key: 'id'},
      {title: 'ID Море звонков', key: 'mz_id'},
      {title: 'Название', key: 'name'},
      // {title: 'Компания', key: 'company'},
      {title: 'Переводы', key: 'hasTransfer'},
      {title: 'Дата редактирования', key: 'edit_date'},
      {title: 'Тип проекта', key: 'project_type'},
      {title: 'Действия ', key: 'actions'}
    ]
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      isModalVisible: false,
      showScript: 0,
      deleteProjectIndex: 0,
      customFieldTypes: ['text', 'email', 'radio', 'checkbox', 'select', 'textarea'],
      sortKey: '',
      sortOrders: sortOrders,
      searchQuery: '',
      selectedFilter: '',
      selectTransfer: '',
      columnsHeader: columnsHeader,
      projects: [],
      currentFieldtNewID: -1,
      currentResultNewID: -1
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    filteredProjects: function () {
      var sortKey = this.sortKey
      var filterKey = this.searchQuery
      var projects = this.projects
      var selectedFilter = this.selectedFilter
      var selectTransfer = this.selectTransfer
      var order = this.sortOrders[sortKey] || 1
      if (filterKey || (selectedFilter != '') || (selectTransfer != '')) {
        projects = this.projects.filter(function (row) {
          return Object.keys(row).some(function (key) {
            if (selectedFilter == 'Базовый') {
              if (row['project_type'] != 'Базовый') {
                return false
              }
            }
            if (selectedFilter == 'Индивидуальный') {
              if (row['project_type'] != 'Индивидуальный') {
                return false
              }
            }
            if (selectTransfer == '1') {
              if (!row['hasTransfer']) {
                return false
              }
            }
            if (selectTransfer == '2') {
              if (row['hasTransfer']) {
                return false
              }
            }
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        projects = projects.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return projects
    },
    commonResults: function () {
      return this.formData.results.filter(item => item.project_id == 0)
    },
    specialResults: function () {
      return this.formData.results.filter(item => item.project_id != 0)
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    formData: {
      get: function () {
        return this.$store.getters.formData
      },
      set: function (newValue) {
        this.$store.commit('setFormData', newValue)
      }
    },
    displayLastCall: {
      get() {
        return this.formData.displayLastCall;
      },
      set(value) {
        this.$store.commit('updateLastCall', value === true ? 1 : 0);
      }
    },
    currentUser () {
      return this.$store.getters.user
    }
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key
      this.sortOrders[key] *= -1
    },
    showModal (mzid = 0) {
      this.isModalVisible = true
      this.showScript = mzid
    },
    closeModal () {
      this.isModalVisible = false
    },
    getProjectData (id) {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getProject&id=' + id)
        .then(response => {
          this.formData = response.data.project
          this.formData.customFields = response.data.fields
          this.formData.deletedFields = []
          this.formData.results = response.data.results
          this.formData.deletedResults = []
          this.formData.mz_api_host = this.systemSettings.mz_api_host
          if (this.formData.hasTransfer != '') {
            this.formData.transfers = JSON.parse(this.formData.transfers)
          }
          this.formData = JSON.parse(JSON.stringify(this.formData))
          // console.log(this.formData)
        })
    },
    createProject () {
      // this.refreshFormData()
      this.getProjectData(0)
      this.showModal()
    },
    saveProject (response) {
      var project = {}
      project = response.data.project
      if (this.formData.id === 0) {
        this.projects.unshift(project)
        // console.log('insert')
      } else {
        var index = this.projects.map(function (el) { console.log(el); return el.id * 1 }).indexOf(project.id)
        var keys = Object.keys(project)
        for (var ind in keys) {
          var key = keys[ind]
          // console.log(key)
          this.projects[index][key] = project[key]
        }
      }
    },
    deleteProject (response) {
      var data = response.data
      if (!data.error) {
        this.projects.splice(this.deleteProjectIndex, 1)
      } else {
        alert('Ошибка удаления проекта ' + data.error_description)
      }
    },
    importProject (mzid) {
      var p = {
        action: 'importProject',
        project_mz_id: mzid
      }
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(response => (console.log(response)))
      // this.projects.splice(index, 1)
    },
    importAllProjects () {
      var p = {
        action: 'importAllProjects'
      }
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(response => (console.log(response)))
      // this.projects.splice(index, 1)
    },

    formSubmit (event) {
      var p = this.formData
      p.action = 'saveProject'
      // console.log(p)
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(this.saveProject)
      this.closeModal()
    },
    addCustomField () {
      this.currentFieldtNewID--
      var field = {id: this.currentFieldtNewID, name: '', label: '', type: 'text', is_required: false, values: []}
      this.formData.customFields.push(field)
    },
    deleteCustomField (index) {
      if (this.formData.customFields[index].id > 0) {
        this.formData.deletedFields.push(this.formData.customFields[index].id)
      }
      this.formData.customFields.splice(index, 1)
    },
    addSpecialResult (projectId) {
      this.currentResultNewID--
      var result = {id: this.currentResultNewID, is_editable: true, name: "", project_id: projectId}
      this.formData.results.push(result)
    },
    editSpecialResults (id) {
      var result = this.formData.results.find((item) => item.id === id)
      result.is_editable = true
    },
    deleteSpecialResults (id) {
      var index = this.formData.results.indexOf(this.formData.results.find((item) => item.id === id))
      this.formData.deletedResults.push(this.formData.results[index].id)
      this.formData.results.splice(index, 1)
    },
    // refreshFormData () {
    //   this.formData = {id: 0, type: '', name: '', mz_id: 0, company: '', client_id: this.client_id, hasTransfer: 0, greeting: '', edit_date: '', password: '', customFields: [], deletedFields: [], results: []}
    // },
    editProject (id) {
      this.getProjectData(id)
      this.showModal()
      // this.formData.customFields = JSON.parse(JSON.stringify(this.formData.customFields))
    },
    removeItem (index, id) {
      var result = confirm('Подтвердите удаление проекта')
      if (result) {
        var p = {
          action: 'deleteProject',
          id: id
        }
        this.deleteProjectIndex = index
        // console.log(p)
        this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
          .then(this.deleteProject)
        // this.projects.splice(index, 1)
      }
    }
  },
  mounted () {
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getProjectsList&client_id=' + this.client_id)
      .then(response => (this.projects = response.data.projects))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects.vue